module.exports = __webpack_public_path__ + "img/icon-3.1c0ee693.png";